<template>
  <b-card :class="badgeType.class" no-body>
    <div :class="['ribbon', badgeType.colorClass]" v-html="sign">
    </div>
    <slot></slot>
  </b-card>
</template>

<script>
  export default {
    name: 'Badges',
    props: {
      sign: {
        type: String,
        default: ``
      },
      type: {
        type: String,
        default: 'square'
      },
      XaxisL: {
        type: Boolean,
        default: true
      },
      YaxisT: {
        type: Boolean,
        default: true
      },
      color: {
        type: String,
        default: 'default'
      },
      traverse: {
        type: Boolean,
        default: false
      }
    },
    computed: {
      badgeType () {
        var cla = 'ribbon-vwrapper'
        var colorClass = 'ribbon-vertical-l'
        if (this.type === 'necktie') {
          if (this.traverse) {
            this.XaxisL ? cla = 'ribbon-wrapper' : cla = 'ribbon-wrapper-reverse'
            this.XaxisL ? colorClass = 'ribbon-bookmark' : colorClass = 'ribbon-bookmark ribbon-right'
          } else {
            this.XaxisL ? cla = 'ribbon-vwrapper' : cla = 'ribbon-vwrapper-reverse'
            this.XaxisL ? colorClass = 'ribbon-bookmark ribbon-vertical-l' : colorClass = 'ribbon-bookmark ribbon-vertical-r'
          }
        } else if (this.type === 'triangle') {
          if (this.YaxisT) {
            this.XaxisL ? cla = 'ribbon-wrapper' : cla = 'ribbon-wrapper-reverse'
            this.XaxisL ? colorClass = 'ribbon-corner' : colorClass = 'ribbon-corner ribbon-right'
          } else {
            this.XaxisL ? cla = 'ribbon-wrapper-bottom' : cla = 'ribbon-wrapper-right-bottom'
            this.XaxisL ? colorClass = 'ribbon-corner ribbon-bottom' : colorClass = 'ribbon-corner ribbon-right ribbon-bottom'
          }
        } else {
          if (!this.XaxisL) {
            cla = 'ribbon-vwrapper-reverse'
            colorClass = 'ribbon-vertical-r'
          }
        }
        return {
          class: cla,
          XaxisL: this.XaxisL,
          colorClass: 'ribbon-' + this.color + ' ' + colorClass
        }
      }
    },
    mounted () {
      // console.log(this.badgeType)
    },
    data () {
      return {

      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components-base/components-custom/badges/badges.vue